import React from 'react';
import { map } from 'lodash';
export default function TimeTable({ times, divHeight }) {
  return (
    <div>
      {map(times, (timeslot, timeID) => (
        <div
          className="graph-time"
          style={{ height: `${divHeight}px` }}
          key={timeID}
        >
          <span>{timeslot.from}</span>
        </div>
      ))}
    </div>
  );
}
